import { Alert } from 'antd';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { ProgressHistoryGraph } from 'business/dashboard/components/progress-history-graph';
import { DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES } from 'business/dashboard/constants';
import { useProgressHistory } from 'business/dashboard/hooks/use-progress-history';
import { SIMPLE_DATE_FORMAT } from 'technical/string/formatter';
import { minutesToMilliseconds } from 'technical/time-utils/minutes-to-milliseconds';
import { useCurrentDate } from 'technical/time-utils/use-current-date';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';
import Loader from 'ui/loader';

const ProgressHistoryContainer = () => {
  const { currentConstructionSite } = useAppContext();
  const { t } = useTranslation();

  invariant(currentConstructionSite, 'No constructionSite id');

  const { currentDate } = useCurrentDate({
    refreshTimeout: minutesToMilliseconds(DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES),
  });

  const sevenDaysAgo = currentDate.subtract(6, 'day');

  const { loading, error, progressHistory } = useProgressHistory({
    // Format like this to avoid issues with timezone, that could end in today written as yesterday
    startDate: sevenDaysAgo.format(SIMPLE_DATE_FORMAT),
    endDate: currentDate.format(SIMPLE_DATE_FORMAT),
    constructionSiteId: currentConstructionSite.id,
  });

  if (error) {
    return <Alert message={t('errors.error_generic')} type="error" />;
  }

  if (loading || isUndefinedOrNull(progressHistory)) {
    return <Loader />;
  }

  return (
    <ProgressHistoryGraph
      progressHistoryGraphData={progressHistory.graphData}
    />
  );
};

export default ProgressHistoryContainer;
